// 한국 휴대폰 번호 입력 포맷터.
// 손님이 숫자만 입력해도 화면에는 010-XXXX-XXXX 형식으로 자동 하이픈이 들어가도록 한다.
// API 호출 직전에는 @oo/shared 의 normalizePhoneKr 로 하이픈을 제거한 정규형을 만들어 전송한다.

// 입력값(하이픈/공백/문자 섞임 가능) 을 화면 표시용으로 정규화한다.
// 010 / 011~019 모두 처리. 최대 11자리(010) 또는 10자리(011~019) 까지만 받는다.
export function formatPhoneKrInput(raw: string): string {
  const digits = raw.replace(/\D/gu, "").slice(0, 11);
  if (digits.length === 0) {
    return "";
  }
  // 010 (또는 010 으로 시작) - 3-4-4 (총 11자리)
  // 011~019 - 3-3-4 (총 10자리)
  const isMobile010 = digits.startsWith("010");
  if (isMobile010) {
    if (digits.length <= 3) {
      return digits;
    }
    if (digits.length <= 7) {
      return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
  }
  // 011~019 또는 그 외 입력 중에 있는 상태.
  const limited = digits.slice(0, 10);
  if (limited.length <= 3) {
    return limited;
  }
  if (limited.length <= 6) {
    return `${limited.slice(0, 3)}-${limited.slice(3)}`;
  }
  return `${limited.slice(0, 3)}-${limited.slice(3, 6)}-${limited.slice(6, 10)}`;
}
